'use client';
import { Builder, withChildren } from '@builder.io/react';
import { ClickToPurchaseCTA } from 'components/funnel/click-to-purchase-cta';
import { AddToFunnelCart } from '../components/funnel/add-to-funnel-cart';

Builder.register('insertMenu', {
  name: 'Funnel Components',
  items: [
    { name: 'Add to Funnel Cart' },
    { name: 'Click To Purchase CTA' },
  ],
  priority: 5,
});

Builder.registerComponent(ClickToPurchaseCTA,
  {
    name: 'Click To Purchase CTA',
    noWrap: true,
    image: 'https://cdn.builder.io/api/v1/image/assets/IsxPKMo2gPRRKeakUztj1D6uqed2/81a15681c3e74df09677dfc57a615b13',
    description: 'Order a product in funnel if previous order been placed',
    models: ['thank-you', 'funnel-offer'],
    inputs: [
      {
        name: 'variantSku',
        friendlyName: 'Variant SKU',
        type: 'text',
        defaultValue: ''
      },
      {
        name: 'buttonText',
        friendlyName: 'Button Text',
        type: 'text',
        defaultValue: 'Click To Purchase',
        showIf: `options.get('buttonColor') !== 'Text'`
      },
      {
        name: 'buttonHTML',
        friendlyName: 'Button HTML',
        type: 'CQLText',
        defaultValue: '<span>Click To Purchase</span>',
        showIf: `options.get('buttonColor') === 'Text'`,
        helperText: 'This will render inside a button, so functionality will be limited. Divs and Ps will be removed, so multi-line text will not render correctly. Please don\'t add links, the browsers will become very angry.'
      },
      {
        name: 'buttonFontSize',
        friendlyName: 'Button Text Size',
        type: 'number'
      },
      {
        name: 'buttonColor',
        friendlyName: 'Button Color',
        type: 'string',
        enum: [
          'Primary',
          'Primary Inverted',
          'Secondary',
          'Secondary Inverted',
          'ATC Tile',
          '4P Orange 1',
          '4P Orange 2',
          '4P Green',
          'Text'
        ],
        defaultValue: 'Primary'
      },
      {
        name: 'buttonSize',
        friendlyName: 'Button Size',
        type: 'string',
        enum: [
          'Small',
          'Medium',
          'Large'
        ],
        defaultValue: 'Medium',
        helperText: 'Only Applies to 4P Styles'
      },
      {
        name: 'buttonEmbellish',
        friendlyName: 'Button Embellishment',
        type: 'string',
        enum: [
          'None',
          'Circle',
          'Arrows'
        ],
        defaultValue: 'None',
        helperText: 'Only Applies to 4P Styles'
      },
      {
        name: 'purchasedText',
        friendlyName: 'Purchased Text',
        type: 'text',
        defaultValue: 'Purchased!'
      },
      {
        name: 'purchasedFontSize',
        friendlyName: 'Purchased Text Size',
        type: 'number'
      },
      {
        name: 'purchasedIcon',
        friendlyName: 'Purchased Icon',
        type: 'string',
        enum: [
          'Check',
          'Check Rect',
          'Check Rect Rounded',
          'Checkbox'
        ],
        defaultValue: 'Check'
      },
      {
        name: 'onSuccessUrl',
        friendlyName: 'Url to redirect if order placed',
        type: 'string',
      },
      {
        name: 'onExpireUrl',
        friendlyName: 'Url to redirect if session expired',
        type: 'string',
      }
    ],
    defaults: {
      bindings: {
        'component.options.variantSku': 'state.mainOfferSku',
        'component.options.onSuccessUrl': 'state.acceptOfferUrl',
        'component.options.onExpireUrl': 'state.rejectOfferUrl',
      }
    }
  }
);

Builder.registerComponent(withChildren(AddToFunnelCart),
  {
    name: 'Add to Funnel Cart',
    image: 'https://cdn.builder.io/api/v1/image/assets/IsxPKMo2gPRRKeakUztj1D6uqed2/81a15681c3e74df09677dfc57a615b13',
    description: 'Add to a Funnel Cart',
    models: ['funnel-landing'],
    childRequirements: {
      message: 'You can only put Text inside the Add to Funnel Cart component.',
      query: {
        'component.name': { $in: ['CQL Text', 'Text'] },
      },
    },
    inputs: [
      {
        name: 'variantSku',
        friendlyName: 'Variant SKU',
        type: 'text',
        defaultValue: ''
      },
      {
        name: 'buttonText',
        friendlyName: 'Button Text',
        type: 'text',
        defaultValue: 'Add to Cart'
      },
      {
        name: 'buttonColor',
        friendlyName: 'Button Color',
        type: 'string',
        enum: [
          'Primary',
          'Primary Inverted',
          'Secondary',
          'Secondary Inverted',
          '4P Orange 1',
          '4P Orange 2',
          '4P Green'
        ],
        defaultValue: 'Primary'
      },
      {
        name: 'buttonSize',
        friendlyName: 'Button Size',
        type: 'string',
        enum: [
          'Small',
          'Medium',
          'Large'
        ],
        defaultValue: 'Medium',
        helperText: 'Only Applies to 4P Styles'
      },
      {
        name: 'buttonEmbellish',
        friendlyName: 'Button Embellishment',
        type: 'string',
        enum: [
          'None',
          'Circle',
          'Arrows'
        ],
        defaultValue: 'None',
        helperText: 'Only Applies to 4P Styles'
      },
      {
        name: 'buttonFontSize',
        friendlyName: 'Button Text Size',
        type: 'number'
      },
      {
        name: 'productLine',
        friendlyName: 'Product Line',
        type: 'text',
        advanced: true,
        defaultValue: ''
      },
      {
        name: 'funnelName',
        friendlyName: 'Funnel Name',
        type: 'text',
        advanced: true,
        defaultValue: ''
      },
      {
        name: 'lander',
        friendlyName: 'Lander',
        type: 'text',
        advanced: true,
        defaultValue: ''
      },
    ],
    defaults: {
      bindings: {
        'component.options.variantSku': 'state.mainOfferSku',
        'component.options.productLine': 'state.productLine',
        'component.options.funnelName': 'state.funnelName',
        'component.options.lander': 'state.lander',
        'component.options.apiProduct': 'state.apiProduct?.sku ? state.apiProduct : state.product',
      }
    }
  }
);